import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Select,
  Flex,
  Row,
  Col,
  notification,
  Typography,
  TreeSelect,
  Dropdown
} from "antd";
import {
  QuestionCircleOutlined,
  ShrinkOutlined,
  ExpandOutlined,
  DownOutlined
} from "@ant-design/icons";
import CreateAttributeList from "../../common/CreateAttributeList";

import UploadButton from "../../common/UploadButton";
import globalData from "../../../config/global_data";
import ErrorNotification from "../../common/ErrorNotification";
import common_api from "../../../config/common_api";
import { triggerNotification } from "../../common/notify";
const { Text } = Typography;

const ButtonItems = [
  {
    label: 'Save & Draft',
    key: 'saveDraft',
  },
  {
    label: 'Save & Reload',
    key: 'saveReload',
  },
];


const CreateProductDrawer = ({ visible, onClose, setisloader, selected_prod_data = null, onProductCreate, globalList, setGlobalList }) => {
  const [form] = Form.useForm();
  const [ProductTitle, setProductTitle] = useState("New Simple Product");
  const [selectedSku, setSelectedSku] = useState(null);
  const [savedimages, setSavedimgaes] = useState(null);
  const [treeData, setTreeData] = useState(null)
  const [savedattributes, setSavedattributes] = useState(null);
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [SAPSKU_options, setOptions] = useState(null);
  const [stores, setStoreOptions] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [alert, setAlert] = useState({});
  const [data, setData] = useState({})
  const [isExpanded, setIsExpanded] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");

  const handleMenuClick = ({ key }) => {
    form
      .validateFields()
      .then((values) => {
        if (key === 'save') {
          onClose(); // Replace with your actual save logic
        }
      })
      .catch(() => {
        openNotification();
      });
  };

  const handleSaveAndPublishClick = () => {
    form
      .validateFields()
      .then((values) => {
        handleSaveAndPublish(values);
      })
      .catch(() => {
        openNotification();
      });
  };

  useEffect(() => {
    // if (globalData.store_list && globalData.store_list.length > 0) {
    //   setStoreOptions(globalData.store_list);
    // }
    if (globalData.store_list && globalData.store_list.length > 0) {
      let final_storelist=globalData.store_list.filter(val=>val.value!="all")
      
      setStoreOptions(final_storelist);
    }

    if (selected_prod_data && visible) {
      let main_prod_name = selected_prod_data.bc_name ? selected_prod_data.bc_name : selected_prod_data.sapName
      setData(selected_prod_data);
      setProductTitle(main_prod_name || "New Simple Product");
      setSelectedStores(selected_prod_data.store);

      const store_id_data = globalData.store_list?.filter(
        (item) => item.value === selected_prod_data.store
      );

      if (store_id_data?.[0]) {
        if (globalData.sap_sku_list?.length > 0) {
          const sapsku = globalData.sap_sku_list.filter(
            (item) =>
              item.store_id === store_id_data[0].store_id &&
              item.prod_count < 1 &&
              item.variant_count < 1
          );
          setOptions(sapsku);
        }

        if (globalData.all_cat_list?.length > 0) {
          const cattree = globalData.all_cat_list.filter(
            (item) => item.store_id === store_id_data[0].store_id
          );
          if (cattree?.[0]?.treedata) {
            setTreeData(cattree[0].treedata);
          }
        }
      }

      form.setFieldsValue({
        msrpPrice: selected_prod_data.sapMsrp.replace(selected_prod_data.currency_symbol, ""),
        salePrice: selected_prod_data.sapPrice.replace(selected_prod_data.currency_symbol, ""),
        SAPmsrp: selected_prod_data.sapMsrp.replace(selected_prod_data.currency_symbol, ""),
        SAPPrice: selected_prod_data.sapPrice.replace(selected_prod_data.currency_symbol, ""),
        pname: selected_prod_data.bc_name || selected_prod_data.sapName,
        sap_sku_select: selected_prod_data.sapSku,
        store: selected_prod_data.store,
      });
    }

    // savedimages(null);
  }, [globalData, selected_prod_data, form]);


  const handleInputChange = (name) => (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    form.setFieldsValue({ [name]: value });
  };
  const handleAlert = async (type, title, message, isopen) => {
    setAlert({ type, title, message, isopen });
    setTimeout(() => setAlert({ isopen: false }), 100);
  };
  const handleSaveAndPublish = async (values) => {
    let images = [], remove_from_GCP = []
    if (savedimages.image_data && savedimages.image_data.length > 0) {
      images = await savedimages.image_data.map(item => {
        if (item.thumbUrl && item.thumbUrl.startsWith('https://storage.googleapis.com/')) {
          remove_from_GCP.push(item.thumbUrl)
        }
        if (item.is_saved) {
          return {
            id: item.is_saved,
            url_standard: item.thumbUrl
          }
        } else {
          return {
            image_url: item.thumbUrl
          }
        }
      })
    }
    let custom_fields_final = [];

    if (savedattributes.custom_fields && savedattributes.custom_fields.length > 0) {
      const data = savedattributes.custom_fields;
      await data.forEach(attr => {
        const { pattern, values, attribute_key, max_size } = attr;
        let baseKey = attribute_key
        let counter = 1;

        values.forEach((item, index) => {
          if (item) {
            let itemobj = {}
            if (baseKey.includes("NUM")) {
              itemobj = {
                "name": baseKey.replace("NUM", counter),
                "value": item
              }
            } else if (max_size === 1) {
              itemobj = {
                "name": baseKey,
                "value": item
              }
            }
            else {
              itemobj = {
                "name": baseKey + "_" + counter,
                "value": item
              }
            }
            custom_fields_final.push(itemobj)
            counter++;
          }
        });
      });
    }

    let req_data = {
      "store": selectedStores,
      "data": {
        "name": values.pname,
        "sku": values.sapSku ? values.sapSku : values.sap_sku_select,
        // "weight": 324,
        "price": values.msrpPrice.replace(data.currency_symbol, ""),
        "sale_price": values.salePrice.replace(data.currency_symbol, ""),
        "images": images && images.length > 0 ? images : [],
        "custom_fields": custom_fields_final,
        "categories": selectedValues,
        "type": "physical",
        "weight": 0
      }
    }
    setisloader(true)
    let responsedata = await common_api.create_simple_product(req_data)
    if (responsedata) {
      let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata, true)
      if (alldata) {
        await setGlobalList(alldata)
      }
      triggerNotification(responsedata)
    }
    setisloader(false)
    onClose()
  }
  const onChange = (values) => {
    setSelectedValues(values);
  };
  const SAPSKU_options_handleChange = async (value) => {
    let store_id_data = await globalData.store_list.filter(item => item.value === selectedStores);
    setSelectedSku(value);

    if (!value) {
      // If cleared, reset the fields
      form.setFieldsValue({
        msrpPrice: "",
        salePrice: "",
        SAPmsrp: "",
        SAPPrice: "",
        pname: "",
      });
      setProductTitle("New Product");
      return;
    }

    let sapsku = await globalData.sap_sku_list.filter(
      item => item.store_id === store_id_data[0].store_id && item.sap_sku == value
    );

    if (sapsku.length > 0) {
      form.setFieldsValue({
        msrpPrice: sapsku[0].sap_msrp,
        salePrice: sapsku[0].sap_sale,
        SAPmsrp: sapsku[0].sap_msrp,
        SAPPrice: sapsku[0].sap_sale,
        pname: sapsku[0].product_name,
      });
      setProductTitle(sapsku[0].product_name);
    } else {
      // If not found, clear the fields
      form.setFieldsValue({
        msrpPrice: "",
        salePrice: "",
        SAPmsrp: "",
        SAPPrice: "",
        pname: "",
      });
      setProductTitle("New Product");
    }
  };
  const store_options_handleChange = async (value) => {    
    
    let store_id_data = await globalData.store_list.filter(item => item.value === value)
    if (globalData.all_cat_list && globalData.all_cat_list.length > 0) {
      let cattree = await globalData.all_cat_list.filter(item => item.store_id === store_id_data[0].store_id)
      setCurrencySymbol(store_id_data[0]?.currency_symbol || "$");
      if (cattree && cattree.length > 0) {
        setTreeData(cattree[0].treedata)
      }
    }
    if (globalData.sap_sku_list && globalData.sap_sku_list.length > 0) {
      let sapsku = await globalData.sap_sku_list.filter(item => item.store_id === store_id_data[0].store_id && item.prod_count < 1 && item.variant_count < 1)
      setOptions(sapsku);
    }
    setSelectedStores(value);
  };

  const openNotification = () => {
    triggerNotification({
      type: 'error',
      title: 'Form incomplete!',
      message: "Please fix all errors before saving.",
    });
  };

  
  const handleBlur = () => {
    const bundleName = form.getFieldValue("pname");
    if (bundleName && bundleName.trim() !== "") {
      setProductTitle(bundleName.trim());
    } else {
      // Revert to original name from selected_prod_data
      const originalName = selected_prod_data?.bc_name || selected_prod_data?.sapName || "New Simple Product";
      setProductTitle(originalName);
    }
  };



  return (
    <Drawer className={`DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
      title={ProductTitle}
      width={isExpanded ? 'calc(100% - 256px)' : 600}
      onClose={onClose}
      open={visible}
      extra={
        <>
          <div className="DrawerButtonBox">
            <Button
              className="ExpandDrawer"
              onClick={() => setIsExpanded(!isExpanded)}
              style={{ marginRight: 8 }}
            >
              {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
            </Button>
            
            <ErrorNotification {...alert} />
            <Dropdown.Button
              type="primary"
              icon={<DownOutlined />}
              menu={{
                items: ButtonItems,
                onClick: handleMenuClick,
              }}
              trigger={['click']}
              onClick={handleSaveAndPublishClick}
              style={{ marginLeft: 8 }}
            >
              Save & Publish
            </Dropdown.Button>
          </div>
        </>
      }
    >
      <Form layout="vertical" form={form}>
        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlexName" : ""}`}>
          <Form.Item
            className="ExpandedFlexProductName"
            label={
              <span>
                Product Name&nbsp;               
              </span>
            }
            name="pname"
            rules={[{ required: true, whitespace: true, message: "Please enter Product name" }]}
          >
            <Input placeholder="Enter a New Product Name" onChange={handleBlur} maxLength={150}/>
          </Form.Item>

          <Flex className="flexbox">
            <Form.Item label={
                <span>
                  Store&nbsp;                 
                </span> } name="store" className="disabledstore">
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="Select Store"
                options={stores}
                onChange={store_options_handleChange}
                disabled={selected_prod_data ? true : false}
                allowClear
              />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  SAP SKU&nbsp;                 
                </span>
              }
              name="sap_sku_select"
              rules={[{ required: true, message: "Please select a SAP SKU" }]}
              className="sap_sku_select"
            >
              <Select
                disabled={selected_prod_data ? true : false}
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Select SAP SKU"
                onChange={SAPSKU_options_handleChange}
                options={SAPSKU_options}
              />
            </Form.Item>



          </Flex>
        </div>

        <Form.Item
          label={
            <span>
              Product Categories&nbsp;              
            </span>
          }

          rules={[{ required: true, message: "Please select at least one category" }]}
        >
          <TreeSelect
            className="CategoryTree"
            multiple
            treeData={treeData}
            onChange={onChange}
            placeholder="Please Select Categories"
            showSearch
            treeDefaultExpandAll
            treeNodeFilterProp="title"
          />
        </Form.Item>
        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlexRow" : ""}`}>
          <Row gutter={8} className="ExpandedFlexRowInner">
            <Col span={12}>
              <Form.Item
                label={
                  <span>
                    Store MSRP&nbsp;                   
                  </span>
                }
                name="msrpPrice"
                rules={[
                  { required: true, message: "Please enter the Store MSRP" },
                ]}
              >
                <Input
                  placeholder="Enter Store MSRP"
                  prefix={currencySymbol || "$"}
                  onChange={handleInputChange("msrpPrice")}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span>
                    Store Sale Price&nbsp;                    
                  </span>
                }
                name="salePrice"
                rules={[
                  { required: true, message: "Please enter the sale price" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const msrp = parseFloat(getFieldValue('msrpPrice'));
                      const sale = parseFloat(value);
                      if (!value || isNaN(msrp) || isNaN(sale) || sale <= msrp) {
                        return Promise.resolve();
                      }
                      return Promise.reject('Sale Price cannot be greater than MSRP');
                    },
                  }),
                ]}
              >
                <Input placeholder="Enter Store Sale Price" prefix={currencySymbol || "$"}
                  onChange={handleInputChange("salePrice")} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={8} className="ExpandedFlexRowInner">
            <Col span={12}>
              <Form.Item
                label="SAP MSRP"
                name="SAPmsrp"
                initialValue="0"
              >
                <Input placeholder="Enter SAP MSRP" disabled prefix={currencySymbol || "$"}/>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="SAP Price"
                name="SAPPrice"
                initialValue="0"
              >
                <Input placeholder="Enter SAP Sale Price" disabled prefix={currencySymbol || "$"}/>
              </Form.Item>
            </Col>
          </Row>
        </div>
        <Form.Item
          label={
            <span>
              PDP Gallery&nbsp;             
            </span>
          }
          name="PDPGallery"
        >
          {visible && <UploadButton setSavedimgaes={setSavedimgaes}
            product_obj={null}
            MAX_UPLOADS="50"
            delete="true"
            replace="true"
            thumbnail="true"
            hover="true" />}
        </Form.Item>

        <div className="ProductDetailBox">
          <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes" : ""}`}>
            {visible && <CreateAttributeList setSavedattributes={setSavedattributes} />}
          </div>
        </div>
      </Form>
    </Drawer>
  );
};

export default CreateProductDrawer;